import type { IconData } from '@stacksjs/iconify-core'

export const chatBubbleOvalSmiley1: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"3\"><path stroke-linecap=\"round\" d=\"M16 30c3.5 5.333 12.5 5.333 16 0M17 17v2m14-2v2\"/><path d=\"M45 24c0-11.598-9.402-21-21-21S3 12.402 3 24c0 3.802 1.01 7.367 2.777 10.443c-.91 2.377-1.768 5.137-2.331 7.896a1.797 1.797 0 0 0 2.197 2.12c2.643-.626 5.325-1.494 7.681-2.371A20.9 20.9 0 0 0 24 45c11.598 0 21-9.402 21-21Z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default chatBubbleOvalSmiley1
